<template>
  <div class="weight-alert">
    <div class="weight-alert__title">{{ alert.title }}</div>
    <ul class="weight-alert__checks">
      <li><strong>{{ texts.SHORT_ALERT_CHECK_TITLE }}</strong> {{ texts.SHORT_ALERT_CHECK_TEXT }}</li>
      <li v-if="alert.cookLines.length">
        <strong>{{ texts.SHORT_ALERT_COOK_TITLE }}</strong>
        <ul class="weight-alert__cook">
          <li v-for="line in alert.cookLines" :key="line.key">{{ line.text }}</li>
        </ul>
      </li>
    </ul>
    <p class="weight-alert__closing">{{ texts.SHORT_ALERT_CLOSING }}</p>
  </div>
</template>

<script>
import { TEXTS } from '../cookedWeightsConstants'

export default {
  name: 'WeightAlert',
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    texts () {
      return TEXTS
    }
  }
}
</script>

<style scoped>
.weight-alert {
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid var(--danger-soft);
  border-left: 3px solid var(--danger-text);
  border-radius: var(--radius);
  font-size: var(--font-small);
  line-height: 1.5;
  color: var(--text-strong);
  background-color: var(--surface);
}

.weight-alert__title {
  margin-bottom: 6px;
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--danger-text);
}

.weight-alert__checks {
  margin: 8px 0 0;
  padding-left: 18px;
  list-style: disc;
}

.weight-alert__checks > li {
  margin-top: 10px;
}

.weight-alert__cook {
  margin: 6px 0;
  padding-left: 22px;
  list-style: circle;
}

.weight-alert__closing {
  margin: 10px 0 0;
  font-weight: 600;
}
</style>
